var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 1.625V6.51953L8.99609 5.39844C9.32422 5.04297 9.89844 5.04297 10.2266 5.39844C10.582 5.72656 10.582 6.30078 10.2266 6.62891L7.60156 9.25391C7.27344 9.60938 6.69922 9.60938 6.37109 9.25391L3.74609 6.62891C3.39062 6.30078 3.39062 5.72656 3.74609 5.39844C4.07422 5.04297 4.64844 5.04297 4.97656 5.39844L6.125 6.51953V1.625C6.125 1.16016 6.50781 0.75 7 0.75C7.46484 0.75 7.875 1.16016 7.875 1.625ZM1.3125 9.5H3.39062C3.71875 9.5 4.01953 9.69141 4.15625 9.99219L4.56641 10.7852C4.70312 11.0859 5.00391 11.25 5.33203 11.25H8.64062C8.96875 11.25 9.26953 11.0859 9.40625 10.7852L9.81641 9.99219C9.95312 9.69141 10.2539 9.5 10.582 9.5H12.6875C13.3984 9.5 14 10.1016 14 10.8125V13.4375C14 14.1758 13.3984 14.75 12.6875 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V10.8125C0 10.1016 0.574219 9.5 1.3125 9.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/in.8c56f8e2101e2b81606efe1a39d43481.svg";